import { Link } from 'react-router'
import { Button } from '#app/components/ui/button.tsx'
import { getAppName, getAppTagline } from '#app/utils/branding.ts'
import { useLocale, useTranslation } from '#app/utils/i18n.ts'
import { useOptionalUser, userHasRoleAtLeast } from '#app/utils/user.ts'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [{ title: getAppName() }]

export default function Index() {
	const t = useTranslation()
	const locale = useLocale()
	const user = useOptionalUser()
	const isStaff = user ? userHasRoleAtLeast(user, 'admin') : false

	return (
		<main className="grid h-full place-items-center">
			<div className="flex max-w-xl flex-col items-center gap-6 px-4 py-16 text-center">
				<h1 className="text-h1">{getAppName()}</h1>
				<p className="text-muted-foreground text-xl/8">
					{getAppTagline(locale)}
				</p>
				<div className="flex flex-wrap justify-center gap-3">
					<Button asChild size="lg">
						<Link to="/apply">{t('home.apply')}</Link>
					</Button>
					{user ? (
						<Button asChild variant="secondary" size="lg">
							<Link to="/cabinet">{t('nav.cabinet')}</Link>
						</Button>
					) : (
						<Button asChild variant="secondary" size="lg">
							<Link to="/login">{t('nav.login')}</Link>
						</Button>
					)}
					{isStaff ? (
						<Button asChild variant="ghost" size="lg">
							<Link to="/applications">{t('nav.applications')}</Link>
						</Button>
					) : null}
				</div>
				<p className="text-muted-foreground max-w-md text-sm">
					{t('home.hint')}
				</p>
			</div>
		</main>
	)
}
